import { ROLES, GENERAL_UNIT_ID } from './constants';
import { effectiveRole, getMembershipForTenant } from './membershipPermissions';
import { QNA_STATUS } from './qnaConstants';

export function canViewAllQuestionUnits(memberships, tenantId, legacyUser) {
  return effectiveRole(memberships, tenantId, legacyUser) === ROLES.ADMIN;
}

export function canAnswerQuestion(memberships, tenantId, legacyUser, question) {
  if (!legacyUser?.uid || !question?.uid) {
    return false;
  }
  if (question.uid === legacyUser.uid) {
    return false;
  }

  const role = effectiveRole(memberships, tenantId, legacyUser);
  if (role === ROLES.ADMIN) {
    return true;
  }
  if (role === ROLES.LOCAL_ADMIN) {
    const membership = getMembershipForTenant(memberships, tenantId);
    const unitIds = membership?.unitIds?.length
      ? membership.unitIds
      : legacyUser?.unit
        ? [legacyUser.unit]
        : [];
    if (!question?.unit || question.unit === GENERAL_UNIT_ID) {
      return false;
    }
    return unitIds.includes(question.unit);
  }
  return false;
}

export function canCloseQuestion(
  legacyUser,
  question,
  { hasOfficialAnswer = false, waitingForAnswer = false } = {},
) {
  if (!legacyUser?.uid || !question?.uid) {
    return false;
  }
  if (question.uid !== legacyUser.uid) {
    return false;
  }
  if (question.status === QNA_STATUS.CLOSED) {
    return false;
  }
  if (waitingForAnswer) {
    return false;
  }
  return hasOfficialAnswer || question.status === QNA_STATUS.ANSWERED;
}

export function canAddFollowUp(legacyUser, question) {
  if (!legacyUser?.uid || !question) {
    return false;
  }
  if (question.status === QNA_STATUS.CLOSED) {
    return false;
  }
  return question.uid === legacyUser.uid;
}

export function canEditQuestionContent(legacyUser, question) {
  if (!legacyUser?.uid || !question) {
    return false;
  }
  return question.uid === legacyUser.uid && question.status === QNA_STATUS.OPEN;
}
